import {DashboardStore} from "store/dashboard/DashboardStore"
import {makeAutoObservable} from "mobx"

export class PathTrackingStore {
    dashboardStore: DashboardStore
    page: number = 0
    pageSize: number = 100
    searchDate: Date = new Date()
    location?: {
        lat: number,
        lng: number,
        no: string,
    }

    constructor(dashboardStore: DashboardStore) {
        this.dashboardStore = dashboardStore
        makeAutoObservable(this)
    }

    setPage = (page: number) => {
        this.page = page
    }
    setLocation = (location?: {
        lat: number,
        lng: number,
        no: string,
    }) => {
        this.location = location
    }
    setSearchDate = (date: Date) => {
        this.searchDate = date
    }
}